export const PREVIOUS = "previous";
export const RESULTS_SUM = "results sum";
export const ZERO = 0;
